import {
    URLAPI,
    RESPONSIBLES_PATH,
    RESPONSIBLE_CREATE_PATH,
    RESPONSIBLE_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_responsibles: {
        data: [],

        status: 0,
        message: {},
    },
    _create_responsible: {
        data: {},
        status: 0,
        message: {},
    },
    _update_responsible: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_RESPONSIBLES = "GET_ALL_RESPONSIBLES";
export const CREATE_RESPONSIBLE = "CREATE_RESPONSIBLE";
export const UPDATE_RESPONSIBLE = "UPDATE_RESPONSIBLE";

export const responsibles_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_RESPONSIBLES:
            return {
                ...state,
                _get_all_responsibles: action.payload,
            };
        case CREATE_RESPONSIBLE:
            return {
                ...state,
                _create_responsible: action.payload,
            };
        case UPDATE_RESPONSIBLE:
            return {
                ...state,
                _update_responsible: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllResponsibles = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${RESPONSIBLES_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_RESPONSIBLES,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_RESPONSIBLES,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_RESPONSIBLES,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};


export const createResponsible = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${RESPONSIBLE_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_RESPONSIBLE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_RESPONSIBLE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_RESPONSIBLE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateResponsible = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${RESPONSIBLE_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_RESPONSIBLE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_RESPONSIBLE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_RESPONSIBLE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_responsibles = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
